<mat-card appearance="outlined" class="card-section">
    <div> You are not authorized to use this app </div>
</mat-card>